import axios from 'axios';
import { WithdrawalPreSaleForm } from '../models/withdrawalModel';

const loadAbort = () => {
  return new AbortController();
};

export const getWithdrawalReasonPreSaleEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/withdrawal-pre-sale/reasons`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createWithdrawalReasonPreSaleEndpoint = (
  form: WithdrawalPreSaleForm,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/ts/v1/admin/withdrawal-pre-sale`,
        data: JSON.stringify(form),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
